<template>
  <div v-bind="$attrs">
    <slot />
    <div class="font-light text-red-500 text-xs h-5" v-if="rules.length">
      <transition
        enter-from-class="-translate-y-full"
        enter-active-class="ease-out duration-300"
        enter-to-class="translate-y-0"
        leave-from-class="translate-y-0"
        leave-active-class="ease-in duration-100"
        leave-to-class="-translate-y-full"
      >
        <div class="transition-transform transform" v-show="errors.length">{{ message }}</div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
    noErrorSpace: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leavingMessage: "",
    };
  },
  computed: {
    message() {
      return this.leavingMessage || (this.errors.length ? this.errors[0] : "");
    },
  },
  watch: {
    errors(newVal, oldVal) {
      if (!newVal.length && oldVal.length) {
        this.leavingMessage = oldVal[0];
        setTimeout(() => {
          this.leavingMessage = "";
        }, 200);
      }
    },
  },
};
</script>
